import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import { PERFORMANCES_VIEW_CURRENT, PERFORMANCES_VIEW_PAST } from 'constants/eventgroup-page-constants'

import Tabs from 'components/tabs'
import PerformanceList from 'components/performance-list'
import LoadMore from 'components/load-more'

import styles from './event-group-home-page.css'

export class EventGroupHomePage extends Component {

  constructor(props) {
    super(props)

    this.handleTabSwitch = this.handleTabSwitch.bind(this)
    this.loadMorePerformances = this.loadMorePerformances.bind(this)
    this.loadMorePastPerformances = this.loadMorePastPerformances.bind(this)
    this.renderPerformanceGroup = this.renderPerformanceGroup.bind(this)
  }

  loadMorePerformances() {
    this.props.eventGroupLoadPerformances(this.props.params.eventGroupId, true)
  }

  loadMorePastPerformances() {
    this.props.eventGroupLoadPastPerformances(this.props.params.eventGroupId, true)
  }

  handleTabSwitch(index) {
    if (index === 0) {
      this.props.eventGroupSetPerformancesViewType(PERFORMANCES_VIEW_CURRENT)
    } else {
      this.props.eventGroupSetPerformancesViewType(PERFORMANCES_VIEW_PAST)
    }
  }

  renderPerformanceGroup({ startTime, group }) {
    const { partner, market } = this.props

    return (
      <PerformanceList
        currencyCode={market.currency.code}
        day={startTime}
        key={startTime}
        partnerId={partner.id}
        performances={group.performances}
        soldTickets={group.soldTickets}
        totalPartnerShare={group.totalPartnerShare}
      />
    )
  }

  renderPerformanceGroups() {
    const { isDataFetching, isDataFetchingPast, pastPerformanceGroups, performanceGroups } = this.props

    if (this.props.showCurrentPerformances) {
      return (
        <RelayoutItem>
          {isDataFetching || (performanceGroups && performanceGroups.length) ?
            performanceGroups.map(this.renderPerformanceGroup)
          :
            <div styleName="emptyEvents">
              There are no upcoming performances for this event
            </div>
          }
          {this.props.canLoadMorePerformances &&
            <LoadMore loading={isDataFetching} onClick={this.loadMorePerformances} />
          }
        </RelayoutItem>
      )
    }

    return (
      <RelayoutItem>
        {isDataFetchingPast || (pastPerformanceGroups && pastPerformanceGroups.length) ?
          pastPerformanceGroups.map(this.renderPerformanceGroup)
        :
          <div styleName="emptyPastEvents">
            There are no past performances for this event
          </div>
        }
        {this.props.canLoadMorePastPerformances &&
          <LoadMore loading={isDataFetchingPast} onClick={this.loadMorePastPerformances} />
        }
      </RelayoutItem>
    )
  }

  render() {
    const { selectedTabIndex } = this.props

    return (
      <div styleName="page">
        <RelayoutWrapper from="md">
          <Relayout align="center">
            <RelayoutItem xl="10">
              <div styleName="tab-container">
                <Tabs active={selectedTabIndex} items={['Current', 'Past']} onChange={this.handleTabSwitch} />
              </div>
              {this.renderPerformanceGroups()}
            </RelayoutItem>
          </Relayout>
        </RelayoutWrapper>
      </div>
    )
  }
}

EventGroupHomePage.propTypes = {
  canLoadMorePastPerformances: PropTypes.bool,
  canLoadMorePerformances: PropTypes.bool,
  eventGroupLoadPastPerformances: PropTypes.func,
  eventGroupLoadPerformances: PropTypes.func,
  eventGroupSetPerformancesViewType: PropTypes.func,
  isDataFetching: PropTypes.bool,
  isDataFetchingPast: PropTypes.bool,
  market: PropTypes.object,
  params: PropTypes.object,
  partner: PropTypes.object,
  pastPerformanceGroups: PropTypes.array,
  performanceGroups: PropTypes.array,
  selectedTabIndex: PropTypes.number,
  showCurrentPerformances: PropTypes.bool,
}

export default CSSModules(EventGroupHomePage, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/event-group-home-page/event-group-home-page.js
 **/